import React, { useState } from 'react';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import { API_BASE } from '../config';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const searchAddress = async (q) => {
  if (q.length < 3) return [];
  const r = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(q)}&format=json&limit=5&accept-language=ar`);
  return r.json();
};

function MapPicker({ onPick }) {
  useMapEvents({ click(e) { onPick(e.latlng); } });
  return null;
}

export default function NewOrder({ onOrderCreated, token }) {
  const [step, setStep] = useState('form');
  const [pickup, setPickup] = useState(null);
  const [dropoff, setDropoff] = useState(null);
  const [pickupQuery, setPickupQuery] = useState('');
  const [dropoffQuery, setDropoffQuery] = useState('');
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [dropoffSuggestions, setDropoffSuggestions] = useState([]);
  const [pkgType, setPkgType] = useState('document');
  const [pickupNotes, setPickupNotes] = useState('');
  const [senderPhone, setSenderPhone] = useState('');
  const [receiverPhone, setReceiverPhone] = useState('');
  const [dropoffNotes, setDropoffNotes] = useState('');
  const [payment, setPayment] = useState('cash');
  const [mapMode, setMapMode] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [priceInfo, setPriceInfo] = useState(null);

  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  const searchPickup = async (q) => {
    setPickupQuery(q);
    if (q.length >= 3) setPickupSuggestions(await searchAddress(q));
    else setPickupSuggestions([]);
  };

  const searchDropoff = async (q) => {
    setDropoffQuery(q);
    if (q.length >= 3) setDropoffSuggestions(await searchAddress(q));
    else setDropoffSuggestions([]);
  };

  const handleCalculate = async () => {
    if (!pickup || !dropoff) return setError('حدد موقع الاستلام والتسليم');
    setError(''); setLoading(true);
    try {
      const r = await axios.post(`${API_BASE}/orders/calculate-price`, {
        pickup_lat: pickup.lat, pickup_lng: pickup.lng,
        dropoff_lat: dropoff.lat, dropoff_lng: dropoff.lng,
      });
      setPriceInfo(r.data);
      setStep('confirm');
    } catch (err) {
      setError(err.response?.data?.error || 'حصل خطأ');
    } finally { setLoading(false); }
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const r = await axios.post(`${API_BASE}/orders`, {
        pickup_address: pickup.address, pickup_lat: pickup.lat, pickup_lng: pickup.lng,
        dropoff_address: dropoff.address, dropoff_lat: dropoff.lat, dropoff_lng: dropoff.lng,
        package_type: pkgType, payment_method: payment,
        pickup_notes: pickupNotes||null, dropoff_notes: dropoffNotes||null,
        sender_phone: senderPhone||null, receiver_phone: receiverPhone||null,
      });
      onOrderCreated(r.data.order);
    } catch (err) {
      const errMsg = err.response?.data?.error || 'حصل خطأ';
      setError(errMsg);
      if (errMsg.includes('محفظة')) {
        // Stay on confirm screen to show wallet error
      } else {
        setStep('form');
      }
    } finally { setLoading(false); }
  };

  if (step === 'confirm' && priceInfo) return (
    <div style={{direction:'rtl',padding:'20px',background:'#f5f6fa',minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'#fff',borderRadius:'20px',padding:'30px',maxWidth:'380px',width:'100%',boxShadow:'0 4px 20px rgba(0,0,0,0.1)',textAlign:'center'}}>
        <p style={{fontSize:'48px',margin:'0 0 10px'}}>🛵</p>
        <h2 style={{margin:'0 0 20px',color:'#1a1a2e',fontSize:'22px'}}>تفاصيل الرحلة</h2>
        <div style={{background:'#f8f9ff',borderRadius:'14px',padding:'16px',marginBottom:'20px',textAlign:'right'}}>
          <p style={{margin:'8px 0',fontSize:'14px',color:'#555'}}>📍 من: {pickup.address}</p>
          <p style={{margin:'8px 0',fontSize:'14px',color:'#555'}}>🏁 إلى: {dropoff.address}</p>
          <p style={{margin:'8px 0',fontSize:'14px',color:'#555'}}>📏 المسافة: {priceInfo.distance_km} كم</p>
          <p style={{margin:'8px 0',fontSize:'14px',color:'#555'}}>💳 الدفع: {payment === 'wallet' ? 'محفظة' : 'كاش'}</p>
        </div>
        <div style={{background:'linear-gradient(135deg,#10b981,#059669)',borderRadius:'14px',padding:'20px',marginBottom:'24px',color:'#fff'}}>
          <p style={{margin:'0 0 4px',fontSize:'14px',opacity:0.8}}>إجمالي التكلفة</p>
          <p style={{margin:0,fontSize:'36px',fontWeight:'bold'}}>{priceInfo.price} جنيه</p>
        </div>
        {error && <p style={{color:'#e74c3c',fontSize:'13px',marginBottom:'12px'}}>{error}</p>}
        <button onClick={handleConfirm} disabled={loading} style={{width:'100%',padding:'16px',background:'linear-gradient(135deg,#10b981,#059669)',color:'#fff',border:'none',borderRadius:'14px',fontSize:'16px',fontWeight:'bold',cursor:'pointer',marginBottom:'10px'}}>
          {loading ? '⏳ جاري الإرسال...' : '✅ تأكيد الطلب'}
        </button>
        <button onClick={()=>setStep('form')} style={{width:'100%',padding:'14px',background:'#eee',color:'#555',border:'none',borderRadius:'14px',fontSize:'15px',cursor:'pointer'}}>
          ← تعديل الطلب
        </button>
      </div>
    </div>
  );

  return (
    <div style={{direction:'rtl',padding:'20px',background:'#f5f6fa',minHeight:'100vh',paddingBottom:'80px'}}>
      <h2 style={{color:'#1a1a2e',margin:'0 0 20px',fontSize:'20px'}}>🚀 طلب توصيل جديد</h2>

      <div style={S.card}>
        <p style={S.label}>📍 موقع الاستلام</p>
        <input value={pickupQuery} onChange={e=>searchPickup(e.target.value)} placeholder="ابحث عن العنوان..." style={S.input}/>
        {pickupSuggestions.length > 0 && (
          <div style={S.suggestions}>
            {pickupSuggestions.map((s,i) => (
              <div key={i} style={S.suggestion} onClick={()=>{
                setPickup({lat:parseFloat(s.lat),lng:parseFloat(s.lon),address:s.display_name});
                setPickupQuery(s.display_name); setPickupSuggestions([]);
              }}>{s.display_name}</div>
            ))}
          </div>
        )}
        {pickup && <p style={S.selected}>✅ {pickup.address.substring(0,60)}...</p>}
        <button onClick={()=>{
          if (!navigator.geolocation) return alert('المتصفح لا يدعم GPS');
          navigator.geolocation.getCurrentPosition(async pos => {
            const {latitude:lat, longitude:lng} = pos.coords;
            const r = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);
            const d = await r.json();
            setPickup({lat, lng, address: d.display_name});
            setPickupQuery(d.display_name);
          }, () => alert('تعذر تحديد موقعك'));
        }} style={{...S.mapBtn, background:'#f0fff0', borderColor:'#27ae60', color:'#27ae60', marginLeft:'8px'}}>📍 موقعي الحالي</button>
        <button onClick={()=>setMapMode(mapMode==='pickup'?null:'pickup')} style={S.mapBtn}>🗺️ اختر من الخريطة</button>
        {pickup && <textarea value={pickupNotes} onChange={e=>setPickupNotes(e.target.value)} placeholder="تفاصيل إضافية لموقع الاستلام (اختياري)..." style={{width:'100%',padding:'10px',border:'1px solid #ddd',borderRadius:'10px',fontSize:'13px',boxSizing:'border-box',resize:'none',height:'60px',marginTop:'8px',direction:'rtl'}}/>}
      </div>

      <div style={S.card}>
        <p style={S.label}>🏁 موقع التسليم</p>
        <input value={dropoffQuery} onChange={e=>searchDropoff(e.target.value)} placeholder="ابحث عن العنوان..." style={S.input}/>
        {dropoffSuggestions.length > 0 && (
          <div style={S.suggestions}>
            {dropoffSuggestions.map((s,i) => (
              <div key={i} style={S.suggestion} onClick={()=>{
                setDropoff({lat:parseFloat(s.lat),lng:parseFloat(s.lon),address:s.display_name});
                setDropoffQuery(s.display_name); setDropoffSuggestions([]);
              }}>{s.display_name}</div>
            ))}
          </div>
        )}
        {dropoff && <p style={S.selected}>✅ {dropoff.address.substring(0,60)}...</p>}
        <button onClick={()=>setMapMode(mapMode==='dropoff'?null:'dropoff')} style={S.mapBtn}>🗺️ اختر من الخريطة</button>
        {dropoff && <textarea value={dropoffNotes} onChange={e=>setDropoffNotes(e.target.value)} placeholder="تفاصيل إضافية لموقع التسليم (اختياري)..." style={{width:'100%',padding:'10px',border:'1px solid #ddd',borderRadius:'10px',fontSize:'13px',boxSizing:'border-box',resize:'none',height:'60px',marginTop:'8px',direction:'rtl'}}/>}
      </div>

      {mapMode && (
        <div style={{...S.card,padding:0,overflow:'hidden'}}>
          <p style={{padding:'10px 16px',margin:0,fontSize:'14px',color:'#666'}}>
            {mapMode==='pickup'?'اضغط لتحديد موقع الاستلام':'اضغط لتحديد موقع التسليم'}
          </p>
          <MapContainer center={[30.0444,31.2357]} zoom={12} style={{height:'250px',width:'100%'}}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
            <MapPicker onPick={async(ll)=>{
              const r = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${ll.lat}&lon=${ll.lng}&format=json`, {headers:{'User-Agent':'besor3a-app/1.0'}});
              const d = await r.json();
              const loc = {lat:ll.lat,lng:ll.lng,address:d.display_name};
              if(mapMode==='pickup'){setPickup(loc);setPickupQuery(d.display_name);}
              else{setDropoff(loc);setDropoffQuery(d.display_name);}
              setMapMode(null);
            }}/>
            {pickup && mapMode==='pickup' && <Marker position={[pickup.lat,pickup.lng]}/>}
            {dropoff && mapMode==='dropoff' && <Marker position={[dropoff.lat,dropoff.lng]}/>}
          </MapContainer>
        </div>
      )}

      <div style={S.card}>
        <p style={S.label}>📦 نوع الطرد</p>
        <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
          {[['document','📄','مستندات'],['small','📦','صغير'],['medium','🗃️','متوسط'],['large','📫','كبير'],['fragile','🥚','هش']].map(([v,ic,lb])=>(
            <button key={v} onClick={()=>setPkgType(v)} style={{padding:'8px 14px',borderRadius:'10px',border:'2px solid',borderColor:pkgType===v?'#10b981':'#ddd',background:pkgType===v?'#f0f0ff':'#fff',cursor:'pointer',fontSize:'13px'}}>
              {ic} {lb}
            </button>
          ))}
        </div>
      </div>

      <div style={S.card}>
        <p style={S.label}>📞 أرقام التواصل</p>
        <label style={{...S.label, fontWeight:'normal'}}>رقم المرسِل (اختياري)</label>
        <input value={senderPhone} onChange={e=>setSenderPhone(e.target.value)} type="tel" placeholder="01xxxxxxxxx" style={{...S.input, marginBottom:'10px', direction:'ltr'}}/>
        <label style={{...S.label, fontWeight:'normal'}}>رقم المرسَل إليه (اختياري)</label>
        <input value={receiverPhone} onChange={e=>setReceiverPhone(e.target.value)} type="tel" placeholder="01xxxxxxxxx" style={{...S.input, direction:'ltr'}}/>
      </div>
      <div style={S.card}>
        <p style={S.label}>💳 طريقة الدفع</p>
        <div style={{display:'flex',gap:'10px'}}>
          {[['cash','💵','كاش'],['wallet','💳','محفظة']].map(([v,ic,lb])=>(
            <button key={v} onClick={()=>setPayment(v)} style={{flex:1,padding:'12px',borderRadius:'12px',border:'2px solid',borderColor:payment===v?'#10b981':'#ddd',background:payment===v?'#f0f0ff':'#fff',cursor:'pointer',fontSize:'14px',fontWeight:'bold'}}>
              {ic} {lb}
            </button>
          ))}
        </div>
      </div>

      {error && <p style={{color:'#e74c3c',textAlign:'center',fontSize:'14px'}}>{error}</p>}

      <button onClick={handleCalculate} disabled={loading||!pickup||!dropoff} style={{width:'100%',padding:'16px',background:(!pickup||!dropoff)?'#ccc':'linear-gradient(135deg,#10b981,#059669)',color:'#fff',border:'none',borderRadius:'14px',fontSize:'16px',fontWeight:'bold',cursor:(!pickup||!dropoff)?'not-allowed':'pointer',marginTop:'10px'}}>
        {loading ? '⏳ جاري الحساب...' : '💰 احسب السعر وتابع'}
      </button>
    </div>
  );
}

const S = {
  card: { background:'#fff',borderRadius:'14px',padding:'16px',marginBottom:'14px',boxShadow:'0 2px 8px rgba(0,0,0,0.06)' },
  label: { margin:'0 0 10px',fontWeight:'bold',fontSize:'14px',color:'#333' },
  input: { width:'100%',padding:'12px',border:'1px solid #ddd',borderRadius:'10px',fontSize:'14px',boxSizing:'border-box' },
  suggestions: { border:'1px solid #ddd',borderRadius:'10px',marginTop:'4px',overflow:'hidden',maxHeight:'150px',overflowY:'auto' },
  suggestion: { padding:'10px 14px',cursor:'pointer',fontSize:'13px',borderBottom:'1px solid #f0f0f0' },
  selected: { color:'#27ae60',fontSize:'12px',margin:'8px 0 0' },
  mapBtn: { marginTop:'10px',padding:'8px 16px',background:'#f0f4ff',border:'1px solid #10b981',borderRadius:'10px',color:'#10b981',cursor:'pointer',fontSize:'13px' },
};
